<example-shell
  exampleId="conditional-styles" [title]="title" [summary]="summary" [dataSnippet]="dataSnippet" [events]="events" (clear)="clearEvents()">
  <stackline-data-table
    title="Inventory risk"
    [columns]="inventoryColumns"
    [data]="inventory"
    [conditionalRowStyles]="inventoryStyles"
    [striped]="true"
    [highlightOnHover]="true">
  </stackline-data-table>
</example-shell>
